<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="គណនីអ្នកគណនេយ្យទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតគណនីអ្នកគណនេយ្យថ្មី" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<md-table>
				<md-table-row>
					<md-table-head>ល.រ.</md-table-head>
					<md-table-head>ឈ្មោះចូលគណនី</md-table-head>
					<md-table-head>ឈ្មោះ និងទូរស័ព្ទ</md-table-head>
					<md-table-head>ទឹកប្រាក់បានធ្វើការទូទាត់</md-table-head>
					<md-table-head>ថ្ងៃបង្កើត</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(admin, index) in adminList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell><b>{{ admin.username }}</b></md-table-cell>
					<md-table-cell>{{ admin.name }}<br>{{ admin.phone_number }}</md-table-cell>
					<md-table-cell>{{ config.moneylify(admin.credit_balance_usd) }} + {{ config.moneylify(admin.credit_balance_khr, "khr") }}</md-table-cell>
					<md-table-cell>{{ config.datelify(admin.created_date) }}</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="showPayAction(admin.admin_id)">
							<md-icon>price_check</md-icon>
							<md-tooltip md-direction="top">ទូទាត់</md-tooltip>
						</md-button>
						<router-link :to="'/accountants/edit/' + admin.admin_id">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែ</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(admin.admin_id)">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">លុប</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<div v-if="tabName == 'second' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<label>ឈ្មោះ</label>
						<md-input v-model="admin.name" type="text" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<label>លេខទូរស័ព្ទ</label>
						<md-input v-model="admin.phoneNumber" type="number" required
							@keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<label>ឈ្មោះចូលគណនី</label>
						<md-input v-model="admin.username" type="text" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>ពាក្យសម្ងាត់</label>
						<md-input v-model="admin.password" type="password" required
							@keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>បញ្ជាក់ពាក្យសម្ងាត់</label>
						<md-input v-model="admin.confirmPassword" type="password" required
							@keyup="checkValidation()"></md-input>
					</md-field>
				</div>

				<div class="md-layout-item md-size-100 text-right">
					<md-button :class="{'md-raised': true, 'md-primary': isValid}" @click="postAdmin()"
						:disabled="!isValid">បង្កើត</md-button>
				</div>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="payDialogActive" md-title="តើអ្នកពិតជាចង់ទូទាត់ប្រាក់សម្រាប់គណនេយ្យនេះមែនទេ ?"
			md-content="ដោយចុច OK គណនេយ្យនេះនឹងត្រូវទូទាត់ប្រាក់ទៅកាន់ ០" md-confirm-text="OK" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onPay" />
		<md-dialog-confirm :md-active.sync="dialogActive" md-title="តើអ្នកពិតជាចង់លុបគណនីនេះមែនទេ ?"
			md-content="ដោយចុច OK នោះគណនីនេះនឹងត្រូវបានលុបជារៀងរហូត" md-confirm-text="OK" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" />
	</div>
</template>

<script>
	export default {
		mounted() {
			if (this.$store.state.authentication.account_type != 'sa') {
				this.$router.push('/dashboard');
			}
		},
		created() {
			this.getAdmin();
		},
		data() {
			return {
				tabName: "first",
				dialogActive: false,
				deleteSelected: '',
				payDialogActive: false,
				paySelected: "",
				loaded: false,
				isValid: false,
				adminList: [],
				admin: {
					name: "",
					phoneNumber: "",
					account_type: "ac",
					username: "",
					password: "",
					confirmPassword: ""
				}
			}
		},
		methods: {
			getAdmin(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/admin/get/list/" + offset).then(data => {

					this.adminList = data.body.data.filter(item => item.account_type === 'ac');
					this.loaded = true;
				})
			},
			loadMore() {
				this.getAdmin(this.adminList.length, false);
			},
			postAdmin() {
				let name = this.admin.name
				let phoneNumber = this.admin.phoneNumber
				let username = this.admin.username
				let password = this.admin.password
				let account_type = this.admin.account_type

				this.clear()
				this.checkValidation()

				this.$http.post(this.config.api + "/admin/admin/post", {
					username,
					name,
					password,
					phoneNumber,
					account_type
				}).then(res => {
					if (res.body.status == 'success') {
						this.tabName = 'first';
						this.$notification.notify({
							message: "គណនីយត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getAdmin();
					}
				})
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.dialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/admin/delete", {
					admin_id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "គណនីយត្រូវបានលុបដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getAdmin();
						this.dialogActive = false
					}
				})

			},
			showPayAction(id) {
				this.paySelected = id
				this.payDialogActive = true
			},
			onPay() {
				this.$http.post(this.config.api + "/admin/admin/clear_credit", {
					admin_id: this.paySelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "គណនីយត្រូវបានទូទាត់ដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getAdmin();
						this.dialogActive = false
						this.payDialogActive = false
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.dialogActive = false
				this.paySelected = ""
				this.payDialogActive = false
			},
			checkValidation() {
				this.admin.username = this.config.validateUsername(this.admin.username);
				if (this.admin.name.length > 3 &&
					this.admin.phoneNumber.length > 8 &&
					this.admin.username.length > 3 &&
					this.config.validateUsername(this.admin.username) == this.admin.username &&
					this.admin.password.length > 6 &&
					this.admin.account_type.length > 0 &&
					this.admin.confirmPassword.length > 6 && this.admin.password == this.admin.confirmPassword) {
					this.isValid = true
				} else {
					this.isValid = false
				}
			},
			clear() {
				this.admin.name = ""
				this.admin.phoneNumber = ""
				this.admin.username = ""
				this.admin.password = ""
				this.admin.confirmPassword = ""
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Accountants/View.vue